import { Component, defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import Suggestions from './Suggestions.class';
import Suggestion from './Suggestion/Suggestion.vue';

export default defineComponent({
	components: {
		Suggestion: Suggestion as Component
	},
	setup: () => {
		const suggestions = new Suggestions();
		return setupComponent(suggestions);
	}
});